import { basicEnum } from "./base";

export const ProvisionSpecStatusEnum = basicEnum([
    {
        label: "Infrastruktur",
        value: "I",
    },
    {
        label: "Kebutuhan Klien",
        value: "C",
    },
]);

export namespace ProvisionSpecStatusEnum {
    export type Labels = (typeof ProvisionSpecStatusEnum)["labels"][number];
    export type Values = (typeof ProvisionSpecStatusEnum)["values"][number];
}
